export default "__VITE_ASSET__cmijejhL__"